import { nextPricerSortState, visiblePricerSort } from "./activeStatus";

export function sortedColumnsFromState(columnState) {
  return (columnState || [])
    .filter((item) => item.sort != null)
    .map((item) => ({
      sort: item.sort,
      colId: item.colId,
      sortIndex: item.sortIndex,
    }));
}

/** Apply only visible sort keys so header badges start at 1. */
export function applyPricerColumnSort(columnApi, stateToSort) {
  if (!columnApi?.applyColumnState) return;
  columnApi.applyColumnState({
    state: visiblePricerSort(stateToSort),
    defaultState: { sort: null },
  });
}

/**
 * If leftover hidden keys are in the model, return the stripped state.
 * null means the model is already user-facing only (including empty).
 */
export function resolvePricerSortChange(columnState) {
  return nextPricerSortState(sortedColumnsFromState(columnState));
}

export function reapplyPricerSort(api) {
  if (!api?.refreshClientSideRowModel) return;
  api.refreshClientSideRowModel("sort");
}
